import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/sticky-kit.js";

import vueRoot from "./modules/vue-root";



import {binder} from "./libs/binder";
import {  constants,  navFunction } from "./modules/module";
import {quotesSlider} from "./modules/quotes-slider";
import {mediaSlider} from "./modules/media-slider";
import {featuredPressSlider} from "./modules/featured-press-slider";
import {accordion} from "./modules/accordion";
import { customSelect } from "./modules/customSelect";
import {bookDropDownToggler} from "./modules/bookDropDownToggler";
import { setStickyElements } from "./modules/stickyElement";
import { tabs } from "./modules/tabs";
import { filters } from './modules/filters';
import {inlineVideo} from "./modules/inline-video";
import { articleEquipment } from './modules/articleEquipment';
import { workoutSlider } from './modules/workout-slider';
import { animationOnScroll } from './modules/animationOnScroll';
import toggleBtn from './modules/toggle-button';
import {selectPricing} from './modules/select-pricing';
import {bookDropDownClose} from './modules/bookDropDownCloseWithoutVue';
import {parallax} from './modules/parallax';
import {iframeFunction} from './modules/iframeFunction';
import {firstEntry} from './modules/first-entry';
import {heroVideo} from './modules/hero-video';
import {formSticky} from './modules/formSticky';

binder({
    bounds: {
        "html": [constants, iframeFunction],
        ".header": [navFunction, bookDropDownToggler],
        ".quotes-slider": quotesSlider,
        ".featured-press-section": featuredPressSlider,
        ".main": mediaSlider,
        ".accordion-section": accordion,
        "select": customSelect,
        ".sticky, .sticky-img img": setStickyElements,
        "#vue-root": [vueRoot,customSelect,toggleBtn],
        ".classes-section, .pricing-tabs, .location-section": tabs,
        //".blog-posts-filter": filters,
        ".inline-video": inlineVideo,
        ".article-block-equipment": articleEquipment,
        ".workout-slider": workoutSlider,
        ".has-animation": animationOnScroll,
        ".pricing-tab": selectPricing,
        ".book-drop-down-wrap": bookDropDownClose,
        ".experience-type": parallax,
        ".first-entry-popup": firstEntry,
        ".hero-section": heroVideo,
        ".landing-form-container": formSticky
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js